import * as types from '../types'
import * as urls from '../urls'
import axios from '@/axios/typhoon_tw'
import {
  pointInterpolation,
  reverseURL
} from '@/util'

const state = {
  data: {
    track: {},
    src_infos: [],
    init_time_zs: [],
    tc_infos: [],
    hourly_points: [],
    wind_files: [],
    typhoon_probability: [],
    satellite_latest_time: null,
  },

  options: {
    selected_src: [],
    selected_tc: [],
    selected_init_time_z: null,
    show_timelabel: true,
    show_graticule: false,
    show_src_name: false,
    // xstep 5
    show_satellite: false,
    show_spotlight: true,
    show_typhoon_probability: false,
    show_probability_chart: false,

    show_wind: true,
    selected_wind_src: 'ncep',
    selected_wind_uri: null,
    // xstep 9
    selected_satellite_data: null,
    focused_tc: {
      trigger: false,
      value: null
    }
  },

  map_options: {
    base_layer: 'satellite',
    center: [20, 120],
    zoom: 4
  },

  wind: {
    files: []
  },

  satellite_data_set: {
    // dtg: data
    // data = [url_set, ...]
    // url_set = {
    //   zoom: 0~5,
    //   dtime: "YYYY-mm-ddTHH-MM-SS+00:00:00"
    //   urls: ['media/**/*.png', ...]
    // }
  },

  dtg: null,
  stop_dtg: null,

  loading_state: 0
}

const getters = {
  [types.GET_TRACK_DATA]: (state) => {
    return state.data.track
  },

  [types.GET_INIT_TIME_Z_LIST]: (state) => {
    return state.data.init_time_zs.sort(function (a, b) {
      return b - a
    })
  },

  [types.GET_SRC_INFO_LIST]: (state) => {
    return state.data.src_infos
  },

  [types.GET_TC_INFO_LIST]: (state) => {
    return state.data.tc_infos
  },

  [types.GET_OPTIONS]: (state) => {
    return state.options
  },

  [types.GET_MAP_OPTIONS]: (state) => {
    return state.map_options
  },

  [types.GET_DTG]: (state) => {
    return state.dtg
  },

  [types.GET_STOP_DTG]: (state) => {
    return state.stop_dtg
  },

  [types.GET_HOURLY_POINTS]: (state) => {
    return state.data.hourly_points
  },

  [types.GET_LOADING_STATE]: (state) => {
    return state.loading_state
  },

  [types.GET_SELECTED_WIND_SOURCE]: (state) => {
    return state.options.selected_wind_src
  },

  [types.GET_WIND_URI]: (state) => {
    return state.options.selected_wind_uri
  },

  [types.GET_FOCUSED_TC]: (state) => {
    return state.options.focused_tc
  },

  [types.GET_TYPHOON_PROBABILITY]: (state) => {
    return state.data.typhoon_probability
  },

  [types.GET_SATELLITE_DATA_SET]: (state) => {
    return state.satellite_data_set
  },

  [types.GET_SATELLITE_LATEST_TIME]: (state) => {
    return state.data.satellite_latest_time
  },
}

const mutations = {
  [types.MUTATIONS_CLEAR_HOURLY_POINTS]: (state) => {
    state.data.hourly_points.splice(0)
  },

  [types.MUTATIONS_DATA]: (state, data) => {
    if (data) {
      if (data.past) {
        state.data.track.past = data.past
      }

      if (data.fcst) {
        state.data.track.fcst = data.fcst
        let src_list = []
        for (let src of state.data.src_infos) {
          // clear all
          // add new property of objects should like this or
          // Vue.set(obj, 'newProp', 123)
          // https://vuex.vuejs.org/guide/mutations.html
          // to use new array to be assigned
          src = {
            ...src,
            has_data: false
          }
          src_list.push(src)
        }
        state.data.src_infos = src_list

        for (let src_fcst of state.data.track.fcst) {
          // for src_infos getting availible srca
          for (let src of state.data.src_infos) {
            if (src.id === src_fcst.src) {
              // src = { ...src, has_data: true }
              src.has_data = true
              src.selected = true

              if (!state.options.selected_src.includes(src.id)) {
                state.options.selected_src.push(src.id)
              }
              break
            }
          }

          // for hourly points
          state.data.hourly_points.push({
            init_time_z: src_fcst.init_time_z,
            src: src_fcst.src,
            tc_name: src_fcst.tc_name,
            track: pointInterpolation(src_fcst.track, src_fcst.src)
          })
        }
      }

      if (data.tc_infos) {
        let tc_list = []
        state.data.tc_infos = data.tc_infos
        // for tc infos
        for (let tc of state.data.tc_infos) {
          tc = {
            ...tc,
            selected: true
          }
          if (!state.options.selected_tc.includes(tc.name)) {
            state.options.selected_tc.push(tc.name)
          }
          tc_list.push(tc)
        }
        state.data.tc_infos = tc_list
      }

      if (data.src_infos) {
        let src_list = []
        state.data.src_infos = data.src_infos
        for (let src of state.data.src_infos) {
          src = {
            ...src,
            selected: false
          }
          src_list.push(src)
        }
        state.data.src_infos = src_list
      }
    }
  },

  [types.MUTATIONS_INIT_TIME_Z_LIST]: (state, data) => {
    if (data.init_time_zs) {
      state.data.init_time_zs = data.init_time_zs
    }
  },

  [types.MUTATIONS_DTG]: (state, data) => {
    state.dtg = data.dtg
  },

  [types.MUTATIONS_STOP_DTG]: (state, data) => {
    state.stop_dtg = data.stop_dtg
  },

  // xstep 3
  [types.MUTATIONS_OPTIONS]: (state, data) => {
    if (data) {
      if (data.selected_src) {
        state.options.selected_src = data.selected_src
      }
      if (data.selected_tc) {
        state.options.selected_tc = data.selected_tc
      }
      if (data.selected_init_time_z) {
        state.options.selected_init_time_z = data.selected_init_time_z
      }
      if (data.selected_wind_src !== undefined && data.selected_wind_src !== null) {
        state.options.selected_wind_src = data.selected_wind_src
      }
      if (data.show_timelabel !== undefined && data.show_timelabel !== null) {
        state.options.show_timelabel = data.show_timelabel
      }
      if (data.show_spotlight !== undefined && data.show_spotlight !== null) {
        state.options.show_spotlight = data.show_spotlight
      }
      if (data.show_src_name !== undefined && data.show_src_name !== null) {
        state.options.show_src_name = data.show_src_name
      }
      if (data.show_satellite !== undefined && data.show_satellite !== null) {
        // xstep 4
        state.options.show_satellite = data.show_satellite
      }
      if (data.show_graticule !== undefined && data.show_graticule !== null) {
        state.options.show_graticule = data.show_graticule
      }
      if (data.show_typhoon_probability !== undefined && data.show_typhoon_probability !== null) {
        state.options.show_typhoon_probability = data.show_typhoon_probability
      }
      if (data.show_probability_chart !== undefined && data.show_probability_chart !== null) {
        state.options.show_probability_chart = data.show_probability_chart
      }
      if (data.show_wind !== undefined && data.show_wind !== null) {
        state.options.show_wind = data.show_wind
      }
      if (data.focused_tc !== undefined && data.focused_tc !== null) {
        state.options.focused_tc.trigger = !state.options.focused_tc.trigger
        state.options.focused_tc.name = data.focused_tc
      }
      if (data.selected_satellite_data !== undefined && data.selected_satellite_data !== null) {
        // xstep 8
        state.options.selected_satellite_data = data.selected_satellite_data
      }
    }
  },

  [types.MUTATIONS_MAP_OPTIONS]: (state, data) => {
    if (data) {
      if (data.base_layer) {
        state.map_options.base_layer = data.base_layer
      }
      if (data.center) {
        state.map_options.center = data.center
      }
      if (data.zoom) {
        state.map_options.zoom = data.zoom
      }
    }
  },

  [types.MUTATIONS_TRIGGER_LOADING]: (state) => {
    state.loading_state += 1
  },

  [types.MUTATIONS_COMPLETE_LOADING]: (state) => {
    let st = state.loading_state - 1
    if (st < 0) {
      state.loading_state = 0
    } else {
      state.loading_state = st
    }
  },

  [types.MUTATIONS_SELECTED_WIND_URI]: (state, uri) => {
    state.options.selected_wind_uri = uri
  },

  [types.MUTATIONS_SELECTED_SATELLITE_DATA]: (state, data) => {
    state.options.selected_satellite_data = data
  },

  [types.MUTATIONS_WIND_FILES]: (state, data) => {
    if (data && data.uri) {
      data.uri = reverseURL(process.env.SERVER_HOST, data.uri)
      state.data.wind_files.push(data)
    }

    if (data.dtg == state.dtg && data.src == state.options.selected_wind_src) {
      state.options.selected_wind_uri = data.uri
    }
  },

  [types.MUTATIONS_SATELLITE_DATA_SET]: (state, data) => {
    state.satellite_data_set = {
      ...state.satellite_data_set,
      [data.dtg]: data.data
    }
    if (data.dtg === state.data.satellite_latest_time) {
      state.options.selected_satellite_data = data.data
    }
  },

  [types.MUTATIONS_TYPHOON_PROBABILITY]: (state, probability) => {
    if (!probability) probability = []
    state.data.typhoon_probability = probability
  },

  [types.MUTATIONS_SATELLITE_LATEST_TIME]: (state, latest_time) => {
    state.data.satellite_latest_time = latest_time
  },

}

const actions = {
  [types.SET_DTG]: ({
    commit
  }, dtg) => {
    commit(types.MUTATIONS_DTG, {
      dtg: dtg
    })
  },

  [types.SET_STOP_DTG]: ({
    commit
  }, stop_dtg) => {
    commit(types.MUTATIONS_STOP_DTG, {
      stop_dtg: stop_dtg
    })
  },

  [types.FETCH_TRACK_DATA]: ({
    commit,
    getters
  }) => {
    commit(types.MUTATIONS_TRIGGER_LOADING)

    let init_time_z = getters[types.GET_OPTIONS].selected_init_time_z
    let query = init_time_z ? {
      dtg: init_time_z
    } : {}
    return new Promise((resolve, reject) => {
      commit(types.MUTATIONS_CLEAR_HOURLY_POINTS)

      axios.get(urls.URL_GET_TRACK_DATA, {
          params: query
        })
        .then(res => {
          commit(types.MUTATIONS_COMPLETE_LOADING)
          commit(types.MUTATIONS_DATA, res.data.result)
          resolve()
        })
        .catch(error => {
          commit(types.MUTATIONS_COMPLETE_LOADING)
          reject(error)
        })
    })
  },

  // xstep 2
  [types.SET_OPTIONS]: ({
    commit
  }, data) => {
    if (data.selected_init_time_z) {
      commit(types.MUTATIONS_DTG, {
        dtg: data.selected_init_time_z
      })
    }
    commit(types.MUTATIONS_OPTIONS, data)
  },

  [types.SET_MAP_OPTIONS]: ({
    commit
  }, data) => {
    commit(types.MUTATIONS_MAP_OPTIONS, data)
  },

  [types.FETCH_SRC_INFOS]: ({
    commit
  }) => {
    return new Promise((resolve, reject) => {
      //
      // 幾乎不會變, 先寫死吧
      //
      commit(types.MUTATIONS_DATA, {
        'src_infos': [{
          "id": "NMC",
          "name_zhtw": "\u4e2d\u570b",
          "name_enus": "NMC",
          "color": "#0f0",
          "order": 5
        }, {
          "id": "PAGASA",
          "name_zhtw": "\u83f2\u5f8b\u8cd3",
          "name_enus": "PAGASA",
          "color": "#d3f",
          "order": 7
        }, {
          "id": "CWB",
          "name_zhtw": "\u53f0\u7063",
          "name_enus": "CWB",
          "color": "#5df",
          "order": 1
        }, {
          "id": "HKO",
          "name_zhtw": "\u9999\u6e2f",
          "name_enus": "HKO",
          "color": "#dd0",
          "order": 6
        }, {
          "id": "JMA",
          "name_zhtw": "\u65e5\u672c",
          "name_enus": "JMA",
          "color": "#aaf",
          "order": 2
        }, {
          "id": "JTWC",
          "name_zhtw": "\u7f8e\u8ecd",
          "name_enus": "JTWC",
          "color": "#f22",
          "order": 3
        }, {
          "id": "KMA",
          "name_zhtw": "\u97d3\u570b",
          "name_enus": "KMA",
          "color": "#f96",
          "order": 4
        },
        {
          "id": "FNV3",
          "name_zhtw": "FNV3",
          "name_enus": "FNV3",
          "is_active": 1,
          "color": "#2563EB",
          "order": 7
        },
        {
          "id": "GENC",
          "name_zhtw": "GENC",
          "name_enus": "GENC",
          "is_active": 1,
          "color": "#0F766E",
          "order": 8
        },
        {
          "id": "GRPH",
          "name_zhtw": "GRPH",
          "name_enus": "GRPH",
          "is_active": 1,
          "color": "#9333EA",
          "order": 9
        }
      ]
      })
      resolve()
    })
  },

  [types.FETCH_INIT_TIME_Z_LIST]: ({
    commit,
    dispatch,
    getters
  }) => {
    let dtg = getters[types.GET_DTG]
    let query = dtg ? {
      dtg: dtg
    } : {}

    commit(types.MUTATIONS_TRIGGER_LOADING)
    return new Promise((resolve, reject) => {
      axios.get(urls.URL_GET_INIT_TIME_ZS, {
          params: query
        })
        .then(res => {
          let init_time_zs = res.data.result
          commit(types.MUTATIONS_INIT_TIME_Z_LIST, {
            'init_time_zs': init_time_zs
          })
          if (init_time_zs.length === 0) {
            dispatch(types.SET_OPTIONS, {
              selected_init_time_z: dtg
            })
          } else {
            dispatch(types.SET_OPTIONS, {
              selected_init_time_z: init_time_zs[init_time_zs.length - 1]
            })
          }
          resolve()
        })
        .catch(error => {
          reject(error)
        })
        .finally(() => {
          commit(types.MUTATIONS_COMPLETE_LOADING)
        })
    })
  },

  [types.INITIALIZE]: ({
    state,
    commit,
    dispatch
  }, dtg) => {
    if (!dtg) {
      dtg = new Date()
      dtg.setMinutes(0)
      dtg = dtg.toUTC().dtgftime()
    }

    state.dtg = dtg

    commit(types.MUTATIONS_TRIGGER_LOADING)
    return new Promise((resolve, reject) => {
      dispatch(types.FETCH_SRC_INFOS).then(() => {
          dispatch(types.FETCH_INIT_TIME_Z_LIST)
            .then(() => resolve())
            .catch(error => reject(error))
        })
        .catch(error => reject(error))
        .finally(() => {
          commit(types.MUTATIONS_COMPLETE_LOADING)
        })
    })
  },

  [types.FETCH_WIND_FILE]: ({
    state,
    commit,
    getters
  }) => {
    let dtg = getters[types.GET_DTG]
    let src = getters[types.GET_SELECTED_WIND_SOURCE]
    if (dtg && src) {
      let is_exist = false
      for (let wind_file_obj of state.data.wind_files) {
        if (wind_file_obj.src == src && wind_file_obj.dtg == dtg) {
          commit(types.MUTATIONS_SELECTED_WIND_URI, wind_file_obj.uri)
          is_exist = true
        }
      }

      if (!is_exist) {
        let uri = urls.URL_GET_WIND_FILE + dtg + '/' + src + '/';
        return new Promise((resolve, reject) => {
          axios.get(uri, {})
            .then(res => {
              let best_file = res.data

              if (best_file.uri) {
                commit(types.MUTATIONS_WIND_FILES, best_file)
              } else {
                commit(types.MUTATIONS_WIND_FILES, {
                  'dtg': dtg,
                  'src': src,
                  'mode': 'bin',
                  'uri': null
                })
              }
              resolve()
            })
            .catch(error => {
              reject(error)
            })
        })
      }
    }
  },

  [types.RESET_WIND]: ({
    commit
  }) => {
    commit(types.MUTATIONS_SELECTED_WIND_URI, null)
  },

  // xstep 7
  [types.FETCH_SATELLITE_DATA]: ({
    state,
    commit,
    getters
  }) => {

    let dtg = getters[types.GET_SATELLITE_LATEST_TIME]
    let satellite_data_set = getters[types.GET_SATELLITE_DATA_SET]
    if (dtg) {
      return new Promise((resolve, reject) => {
        if (satellite_data_set.hasOwnProperty(dtg)) {
          commit(types.MUTATIONS_OPTIONS, {
            selected_satellite_data: satellite_data_set[dtg]
          })
          resolve()
        } else {
          axios.get(urls.URL_GET_SATELLITE_IMAGE_INFO, {
              params: {
                dtime: dtg ? dtg.isostrz() : null
              }
            })
            .then(res => {
              if (res.data.length > 0) {
                // 2022-01-27 @X uri is a legacy naming of satellite image infos
                // TODO: Change 'uri' to a better name.
                commit(types.MUTATIONS_SATELLITE_DATA_SET, {
                  dtg,
                  data: res.data
                })
              } else {
                commit(types.MUTATIONS_OPTIONS, {
                  selected_satellite_data: ''
                })
              }
              resolve()
            })
            .catch(error => {
              commit(types.MUTATIONS_OPTIONS, {
                selected_satellite_data: ''
              })
              reject(error)
            })
        }
      })
    } else {
      commit(types.MUTATIONS_OPTIONS, {
        selected_satellite_data: ''
      })
    }
  },

  [types.RESET_SATELLITE_DATA]: ({
    commit
  }) => {
    commit(types.MUTATIONS_SELECTED_SATELLITE_DATA, null)
  },

  [types.FETCH_TYPHOON_PROBABILITY]: ({
    commit,
    getters
  }) => {
    commit(types.MUTATIONS_TRIGGER_LOADING)
    let init_time_z = getters[types.GET_OPTIONS].selected_init_time_z
    let query = init_time_z ? {
      dtg: init_time_z
    } : {}
    return new Promise((resolve, reject) => {
      axios.get(urls.URL_GET_TYPHOON_PROBABILITY, {
          params: query
        })
        .then(res => {
          commit(types.MUTATIONS_COMPLETE_LOADING)
          commit(types.MUTATIONS_TYPHOON_PROBABILITY, res.data.result)
          resolve()
        }).catch(error => {
          commit(types.MUTATIONS_COMPLETE_LOADING)
          reject(error)
        })
    })
  },

  [types.FETCH_SATELLITE_LATEST_TIME]: ({
    commit,
    getters
  }) => {
    let dtg = getters[types.GET_DTG]
    return new Promise((resolve, reject) => {
      axios.get(urls.URL_GET_SATELLITE_LATEST_TIME, {
          params: {
            dtg: dtg
          }
        })
        .then(res => {
          commit(types.MUTATIONS_SATELLITE_LATEST_TIME, res.data.data ? new Date(res.data.data).toLST() : null)
          resolve()
        }).catch(error => {
          commit(types.MUTATIONS_SATELLITE_LATEST_TIME, null)
          reject(error)
        })
    })
  }

}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/typhoon_tw.js